import React from "react";
import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
// import { a } from "react-router-dom";

export default function Navbar(props) {
    return (
        <div>
            <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
                <div className="container-fluid">
                    <a className="navbar-brand" href="#">
                        {props.title}
                    </a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="/navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            {/* <li className="nav-item">
                                <Link
                                    className="nav-a active navbar-brand"
                                    aria-current="page"
                                    to="/home"
                                >
                                    Home
                                </Link>
                            </li> */}
                            {/* <li className="nav-item">
                                <a className="nav-a navbar-brand" href="#">
                                    {props.about}
                                </a>
                            </li> */}
                        </ul>
                        <div className={`form-check form-switch text-${props.mode === "light" ? "black" : "light"} mx-3 `}>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                onClick={props.toggleMode}
                            // checked
                            />
                            <label className={`form-check-label text-${props.mode === "light" ? "black" : "light"}`} htmlFor="flexSwitchCheckChecked">
                                Enable Darkmode
                            </label>
                        </div>
                        <br />
                        <form className="d-flex" role="search">
                            <input
                                className="form-control me-2 "
                                type="search"
                                placeholder="Search"
                                aria-label="Search"
                            />
                            <button
                                className={`btn btn-outline-primary color-${props.mode === " dark" ? "white" : "black"}`}
                                type="submit"
                            >
                                Search
                            </button>
                        </form>
                    </div>
                </div>
            </nav >
        </div >
    );
}

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    about: PropTypes.string.isRequired,
};

Navbar.defaultProps = {
    title: "Set Title",
    about: "Set about us here",
};
